var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M.75.75h29.5v29.5H.75V.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M24.689 10.727c-.383-1.619-1.097-2.239-2.414-2.463-.755-.119-4.391-.27-7.279-.27s-6.524.151-7.279.27c-1.315.224-2.032.849-2.411 2.463-.13.538-.304 3.513-.304 4.645v.25c0 1.134.174 4.105.304 4.647.379 1.614 1.096 2.236 2.411 2.46.755.12 4.397.268 7.286.268L14.99 23c2.891 0 6.53-.151 7.285-.271 1.317-.224 2.031-.846 2.414-2.46.128-.542.304-3.513.304-4.647v-.25c0-1.132-.176-4.107-.304-4.645zM12.6 18.209v-5.425l4.792 2.649-4.792 2.776z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.a0ac96319da2f7a51d03f5923775971f.svg";
export { ForwardRef as ReactComponent };